import React from "react";

const tableColumnCalonProspek = [
  {
    name: "no",
    label: "No",
    // options: {
    //   sort: false,
    // },
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{rowNumber}</>;
      },
      sort: false,
    },
  },
  {
    name: "nama",
    label: "Nama",
    options: {
      sort: false,
    },
  },
  {
    name: "nik",
    label: "NIK",
    options: {
      sort: false,
    },
  },
  {
    name: "alamat",
    label: "Alamat",
    options: {
      sort: false,
    },
  },
  {
    name: "namaProvinsi",
    label: "Provinsi",
    options: {
      sort: false,
    },
  },
  {
    name: "namaKecamatan",
    label: "Kecamatan",
    options: {
      sort: false,
    },
  },
  {
    name: "namaKelurahan",
    label: "Kelurahan",
    options: {
      sort: false,
    },
  },
  {
    name: "noHp1",
    label: "No. HP 1",
    options: {
      sort: false,
    },
  },
  {
    name: "memberId",
    label: "Member ID",
    options: {
      sort: false,
    },
  },
  {
    name: "memberLevel",
    label: "Member Level",
    options: {
      sort: false,
    },
  },
  {
    name: "loyaltyLevel",
    label: "Loyalty Level",
    options: {
      sort: false,
    },
  },
];

const tableColumnMotorDimiliki = [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{rowNumber}</>;
      },
      sort: false,
    },
  },
  {
    name: "tanggalFJ",
    label: "Tanggal FJ",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorFJ",
    label: "Nomor FJ",
    options: {
      sort: false,
    },
  },
  {
    name: "namaSeries",
    label: "Series",
    options: {
      sort: false,
    },
  },
  {
    name: "namaTipe",
    label: "Tipe",
    options: {
      sort: false,
    },
  },
  {
    name: "kodeVarian",
    label: "Kode Varian",
    options: {
      sort: false,
    },
  },
  {
    name: "namaVarian",
    label: "Varian",
    options: {
      sort: false,
    },
  },
  {
    name: "kodeWarna",
    label: "Kode Warna",
    options: {
      sort: false,
    },
  },
  {
    name: "namaWarna",
    label: "Warna",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorKendaraan",
    label: "Nomor Kendaraan",
    options: {
      sort: false,
    },
  },
  {
    name: "nomorMesin",
    label: "Nomor Mesin",
    options: {
      sort: false,
    },
  },
  {
    name: "jenisPenjualan",
    label: "Jenis Penjualan",
    options: {
      sort: false,
    },
  },
  {
    name: "namaLeasing",
    label: "Leasing",
    options: {
      sort: false,
    },
  },
  {
    name: "jenisKonsumen",
    label: "Jenis Konsumen",
    options: {
      sort: false,
    },
  },

  {
    name: "statusKpb1",
    label: "Status KPB 1",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalJatuhTempoKpb1",
    label: "Tanggal Jatuh Tempo KPB 1",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalKlaimKpb1",
    label: "Tanggal Klaim KPB 1",
    options: {
      sort: false,
    },
  },

  {
    name: "statusKpb2",
    label: "Status KPB 2",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalJatuhTempoKpb2",
    label: "Tanggal Jatuh Tempo KPB 2",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalKlaimKpb2",
    label: "Tanggal Klaim KPB 2",
    options: {
      sort: false,
    },
  },

  {
    name: "statusKpb3",
    label: "Status KPB 3",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalJatuhTempoKpb3",
    label: "Tanggal Jatuh Tempo KPB 3",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalKlaimKpb3",
    label: "Tanggal Klaim KPB 1",
    options: {
      sort: false,
    },
  },

  {
    name: "statusKpb4",
    label: "Status KPB 4",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalJatuhTempoKpb4",
    label: "Tanggal Jatuh Tempo KPB 4",
    options: {
      sort: false,
    },
  },
  {
    name: "tanggalKlaimKpb4",
    label: "Tanggal Klaim KPB 4",
    options: {
      sort: false,
    },
  },
];

const tableColumnChangeData = [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{rowNumber}</>;
      },
      sort: false,
    },
  },
  {
    name: "tanggalPengajuan",
    label: "Tanggal Pengajuan",
    options: {
      sort: false,
    },
  },
  {
    name: "memberId",
    label: "Member ID",
    options: {
      sort: false,
    },
  },
  {
    name: "nama",
    label: "Nama",
    options: {
      sort: false,
    },
  },
  {
    name: "nik",
    label: "NIK",
    options: {
      sort: false,
    },
  },
  {
    name: "noHp1",
    label: "No. HP 1",
    options: {
      sort: false,
    },
  },
  {
    name: "alamat",
    label: "Kota/Kabupaten",
    options: {
      sort: false,
    },
  },
  {
    name: "namaProvinsi",
    label: "Provinsi",
    options: {
      sort: false,
    },
  },
  {
    name: "namaKabkot",
    label: "Kota/Kabupaten",
    options: {
      sort: false,
    },
  },
  {
    name: "namaKecamatan",
    label: "Kecamatan",
    options: {
      sort: false,
    },
  },
  {
    name: "namaKelurahan",
    label: "Kelurahan",
    options: {
      sort: false,
    },
  },
  {
    name: "memberLevel",
    label: "Member Level",
    options: {
      sort: false,
    },
  },
  {
    name: "loyaltyLevel",
    label: "Loyalty Level",
    options: {
      sort: false,
    },
  },
  {
    name: "status",
    label: "Status",
    options: {
      sort: false,
    },
  },
];

const initialFilterCDB = {
  name: null,
  nik: null,
  noHp1: null,
  noHp2: null,
  address: null,
  religion: null,
  job1: null,
  job2: null,
  gender: null,
  kkNumber: null,
  npwp: null,
  province: {},
  kabkot: {},
  kecamatan: {},
  kelurahan: {},
  zipCode: {},
  memberId: {},
  memberLevel: {},
  memberLoyalty: {},
  facebook: {},
  instagram: {},
  linkedin: {},
  twitter: {},
  tiktok: {},
  hobby: [],
  interest: [],
  categoryDISC: [],
  categorySpecial: [],
  noteSpecial: [],
};

export const formGroup = {
  name: { value: "", mandatory: true },
  nik: { value: "", mandatory: true },
  address: { value: "", mandatory: true },
  kkNumber: { value: "", mandatory: true },
  npwp: { value: "" },
  provinceId: { value: "", mandatory: true },
  kabkotId: { value: "", mandatory: true },
  kecamatanId: { value: "", mandatory: true },
  kelurahanId: { value: "", mandatory: true },
  zipcode: { value: "", mandatory: true },
  gender: { value: "", mandatory: true },
  job1: { value: "", mandatory: true },
  job2: { value: "" },
  religion: { value: "", mandatory: true },
  hpNumber1: { value: "", mandatory: true },
  hpNumber2: { value: "" },
  email: { value: "" },
  facebook: { value: "" },
  instagram: { value: "" },
  linkedin: { value: "" },
  twitter: { value: "" },
  tiktok: { value: "" },
  discCategory: { value: "" },
  hobby: { value: [] },
  interest: { value: [] },
  customerId: { value: "" },
  memberLevel: { value: "" },
  loyaltyLevel: { value: "" },
  specialCategory: { value: "" },
  photoKTP: { value: "", mandatory: true },
  specialNotes: { value: "" },
  photoKK: { value: "" },
  photoCustomerUrl: { value: "" },
  kodeCabang: { value: "" },
  prospectDate: { value: null },
  prospectId: { value: "" },
  lastFUStatusH1: { value: "" },
  lastFUStatusH23: { value: "" },
  lastFUDate: { value: null },
  category: { value: "" },
  source: { value: "" },
  sourceCabang: { value: "" },
  lastFollowUpBy: { value: "" },
  type: { value: "" },
  lastBuyDate: { value: null },
  lastServiceDate: { value: null },
  sourceData: { value: "" },
  prospectOwnership: { value: "" },
  lastSeller: { value: "" },
  lastLoginDate: { value: null },
  lastLoginTime: { value: null },
};

export const config = {
  tableColumnCalonProspek,
  tableColumnMotorDimiliki,
  tableColumnChangeData,
  initialFilterCDB,
  formGroup,
};
